import { render, staticRenderFns } from "./CausaMorte.vue?vue&type=template&id=1bdaab50&"
import script from "./CausaMorte.vue?vue&type=script&lang=js&"
export * from "./CausaMorte.vue?vue&type=script&lang=js&"
import style0 from "./CausaMorte.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports